import { SourceInterface, useFeedback, useTranslation } from "@opendash/core";

import { Source } from "@opendash/plugin-parse/dist/types-generated";
import { UploadFile } from "antd";
import Parse from "parse";
import { useState } from "react";
import { Media, Source_File } from "../../../js/parsegenerated";

export default () => {
  const t = useTranslation();
  const { notification } = useFeedback();
  const [saving, setSaving] = useState(false);

  async function saveFiles(
    files: UploadFile[],
    sourceInterface: SourceInterface,
    descriptions: string[]
  ) {
    setSaving(true);
    const source = await new Parse.Query(Source).get(sourceInterface.id);
    const existingSourceFile = await new Parse.Query(Source_File)
      .equalTo("source", source)
      .first();

    try {
      const parseFiles = files.map((file) => {
        return new Parse.File(file.name, file.originFileObj, file.type);
      });

      const savedParseFiles = await Promise.all(
        parseFiles.map((file) => file.save())
      );

      const filesToSave = savedParseFiles.map((file, index) => {
        return new Media({
          media: file,
          description: descriptions[index],
          tenant: Parse.User.current().get("tenant"),
        });
      });

      const savedFiles = await Media.saveAll(filesToSave);

      let sourceFileToSave: Source_File = undefined;
      if (existingSourceFile) {
        sourceFileToSave = existingSourceFile;
      } else
        sourceFileToSave = new Source_File({
          source: source,
          user: Parse.User.current(),
          tenant: Parse.User.current().get("tenant"),
        });

      savedFiles.forEach((file) => {
        sourceFileToSave.files.add(file);
      });

      await sourceFileToSave.save();

      notification.success({
        message: t("maintenance:global.messages.save.success"),
      });
    } catch (e) {
      console.error(e);
      notification.error({
        message: t("maintenance:global.notifications.save.error.title"),
      });
    }
    setSaving(false);
  }

  return { saveFiles, saving };
};
